import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slices/authSlice";
import clientReducer from "./Slices/clientSlice";
import professionalReducer from "./Slices/professionalSlice";
import AdminReducer from "./Slices/AdminSlice";
import ProfileSettingReducer from "./Slices/ProfileSettingSlice";
import serviceAreaReducer from "./Slices/ServiceAreaSlice";
import favoritesReducer from "./Slices/favoritesSlice";
import userCategoryReducer from "./Slices/userCategorySlice";
import marketingPopupReducer from "./Slices/MarketingPopupSlice";
import categoryFormSettingsReducer from "./Slices/CategoryFormSettingsSlice";
import contentManagementReducer from "./Slices/contentManagementSlice";
import regionSettingsReducer from "./Slices/RegionSettingsSlice";
import announcementReducer from "./Slices/AnnouncementSlice";
import languageReducer from "./Slices/LanguageSlice";
import offerReducer from "./Slices/offerSlice";
import chatReducer from "./Slices/chatSlice";
import contractsReducer from "./Slices/contractSlice";
import milestonesReducer from "./Slices/milestoneSlice";
import paymentsReducer from "./Slices/paymentSlice";
import commissionReducer from "./Slices/commissionSlice";
import depositReducer from "./Slices/depositSlice";
import notificationReducer from "./Slices/notificationSlice";
import reviewsReducer from "./Slices/reviewSlice";
import subscriptionPlanReducer from "./Slices/subscriptionPlanSlice";
import creditsReducer from "./Slices/creditSlice";
import quotesReducer from "./Slices/quoteSlice";
import quoteFormSettingsReducer from "./Slices/quoteFormSettingsSlice";
import currenciesReducer from "./Slices/CurrencySlice";
import paymentMilestonesReducer from "./Slices/PaymentMilestoneSlice";
import locationReducer from "./Slices/LocationSlice";
import locationSeoReducer from "./Slices/LocationSeoSlice";
import regionalPricingReducer from "./Slices/RegionalPricingSlice";
import contactInfoReducer from "./Slices/contactInfoSlice";
import commonQuestionsReducer from "./Slices/CommonQuestionsSlice";
import adminGeneralSettingsReducer from "./Slices/AdminGeneralSettingsSlice";
import userPermissionsReducer from "./Slices/UserPermissionsSlice";
import adminSecuritiesReducer from "./Slices/AdminSecuritiesSlice";
import videoCallManagementReducer from "./Slices/VideoCallManagementSlice";
import chatRulesReducer from "./Slices/ChatRulesSlice";
import userNotificationReducer from "./Slices/UserNotificationSlice";
import adminQuotePricingReducer from "./Slices/AdminQuotePricingSlice";
import pageManagementReducer from "./Slices/PageManagementSlice";
import promotionSettingReducer from "./Slices/PromotionSettingSlice";
import invoiceReducer from "./Slices/InvoiceSlice";
import menuLinkReducer from "./Slices/MenuLinkSlice";
import refundRequestReducer from "./Slices/RefundRequestSlice";
import userReducer from "./Slices/userSlice";
import adminProfessionalScoringReducer from "./Slices/adminProfessionalScoringSlice";
import trustpilotReducer from "./Slices/TrustpilotSlice";
import professionalMonitoringReducer from "./Slices/professionalMonitoringSlice";
import achievementReducer from "./Slices/achievementSlice";
import { useDispatch, useSelector } from "react-redux";
import loadingSlice from "./Slices/loadingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    loader: loadingSlice,
    client: clientReducer,
    professional: professionalReducer,
    admin: AdminReducer,
    profileSetting: ProfileSettingReducer,
    serviceArea: serviceAreaReducer,
    favorites: favoritesReducer,
    userCategory: userCategoryReducer,
    marketingPopup: marketingPopupReducer,
    categoryFormSettings: categoryFormSettingsReducer,
    contentManagement: contentManagementReducer,
    regionSettings: regionSettingsReducer,
    announcement: announcementReducer,
    language: languageReducer,
    offers: offerReducer,
    chat: chatReducer,
    contracts: contractsReducer,
    milestones: milestonesReducer,
    payments: paymentsReducer,
    commissions: commissionReducer,
    deposits: depositReducer,
    notification: notificationReducer,
    reviews: reviewsReducer,
    subscriptionPlans: subscriptionPlanReducer,
    credits: creditsReducer,
    quotes: quotesReducer,
    quoteFormSettings: quoteFormSettingsReducer,
    currencies: currenciesReducer,
    paymentMilestones: paymentMilestonesReducer,
    locations: locationReducer,
    locationSeos: locationSeoReducer,
    regionalPricings: regionalPricingReducer,
    contactInfos: contactInfoReducer,
    commonQuestions: commonQuestionsReducer,
    adminGeneralSettings: adminGeneralSettingsReducer,
    userPermissions: userPermissionsReducer,
    adminSecurities: adminSecuritiesReducer,
    videoCallManagement: videoCallManagementReducer,
    chatRules: chatRulesReducer,
    userNotifications: userNotificationReducer,
    adminQuotePricings: adminQuotePricingReducer,
    pageManagements: pageManagementReducer,
    promotionSettings: promotionSettingReducer,
    invoices: invoiceReducer,
    menuLinks: menuLinkReducer,
    refundRequests: refundRequestReducer,
    user: userReducer,
    adminProfessionalScoring: adminProfessionalScoringReducer,
    trustpilot: trustpilotReducer,
    professionalMonitoring: professionalMonitoringReducer,
    achievements: achievementReducer
    // Add more slices here
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T) => useSelector<RootState, T>(selector);